import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  reactive
} from '@vue/composition-api'
import './endAnswer.scss'
const EndAnswer = defineComponent({
  props: {
    endStr: {
      type: String,
      default: ''
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    console.log('props---', props)
    const vm = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return vm?.proxy.$t(initParam) as string
    }

    const state = reactive({
      jumpTime: 0,
      jumpUrl: '',
      isAutoJump: false
    })
    let timer = null
    const isAutoJump = () => {
      //是否需要自动跳转
      const { autoRedirectEnable, autoRedirectTime, autoRedirectUrl } =
        props.config
      state.jumpTime = autoRedirectTime
      state.jumpUrl = autoRedirectUrl
      state.isAutoJump = autoRedirectEnable == '1' ? true : false
      state.isAutoJump &&
        (timer = setInterval(() => {
          if (state.jumpTime === 0) {
            clearInterval(timer)
            window.location.href = state.jumpUrl
          } else {
            state.jumpTime -= 1
          }
        }, 1000))
    }

    onMounted(() => {
      isAutoJump()
    })

    onUnmounted(() => {
      clearInterval(timer)
    })

    return () => {
      return (
        <div class="end-answer-div" style={{ textAlign: 'center' }}>
          {props.endStr && <div domPropsInnerHTML={props.endStr}></div>}
          {!props.endStr && (
            <div class="normal-status">
              <div>{tran('survy.pushsuccess')}</div>
              <div>{tran('survy.afterPush')}</div>
            </div>
          )}
          {state.isAutoJump && (
            // <div class="submit-after-count-down">{state.jumpTime} s</div>
            <div class="submit-after-count-down">
              {props.config.autoRedirectText || tran('survy.jumPage')}，
              {state.jumpTime}s
            </div>
          )}
        </div>
      )
    }
  }
})

export default EndAnswer
